export default "__VITE_ASSET__ilCpQFVw__"